import { useMutation, useQueryClient } from '@tanstack/react-query';
import {
    Assignee,
    AssigneeRequest,
    deleteApplicantAssignee,
    DeleteAssigneeRequest,
    postApplicantAssignee,
} from '../endpoints/applicantAssignees';

export const useAddAssignee = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (request: AssigneeRequest) => {
            return await postApplicantAssignee(request);
        },
        onMutate: async (variables) => {
            // Cancel any outgoing refetches
            await queryClient.cancelQueries({
                queryKey: ['applicant-assignees', variables.applicantId],
            });

            // Snapshot the previous value
            const previousAssignees = queryClient.getQueryData<Assignee[]>([
                'applicant-assignees',
                variables.applicantId,
            ]);

            return { previousAssignees };
        },
        onError: (_err, variables, context) => {
            // Rollback on error
            if (context?.previousAssignees) {
                queryClient.setQueryData(
                    ['applicant-assignees', variables.applicantId],
                    context.previousAssignees,
                );
            }
        },
        onSuccess: (_, variables) => {
            // Invalidate the assignees query to refetch the list with real data from server
            queryClient.invalidateQueries({
                queryKey: ['applicant-assignees', variables.applicantId],
            });
        },
    });
};

export const useDeleteAssignee = () => {
    const queryClient = useQueryClient();

    return useMutation({
        mutationFn: async (request: DeleteAssigneeRequest) => {
            return await deleteApplicantAssignee(request);
        },
        onMutate: async (variables) => {
            // Cancel any outgoing refetches
            await queryClient.cancelQueries({
                queryKey: ['applicant-assignees', variables.applicantId],
            });

            // Snapshot the previous value
            const previousAssignees = queryClient.getQueryData<Assignee[]>([
                'applicant-assignees',
                variables.applicantId,
            ]);

            return { previousAssignees };
        },
        onError: (_err, variables, context) => {
            // Rollback on error
            if (context?.previousAssignees) {
                queryClient.setQueryData(
                    ['applicant-assignees', variables.applicantId],
                    context.previousAssignees,
                );
            }
        },
        onSuccess: (_, variables) => {
            // Invalidate the assignees query to refetch the list with real data from server
            queryClient.invalidateQueries({
                queryKey: ['applicant-assignees', variables.applicantId],
            });
        },
    });
};
